module.exports = __webpack_public_path__ + "img/img5.9ce71d41.png";